import { useCallback, useMemo } from 'react'
import useIsJapan from '@/hooks/use-is-japan'
import { PlatformShortcode } from '@/utils/convert-platform'

export const useShouldDisplayQuotations = (): ((
  platformShortCode?: PlatformShortcode,
) => boolean) => {
  const isJapan = useIsJapan()

  const platforms = useMemo(() => {
    const platforms = [
      PlatformShortcode.Facebook,
      PlatformShortcode.Instagram,
      PlatformShortcode.YouTube,
    ]

    if (isJapan) {
      platforms.push(PlatformShortcode.TikTok)
    }

    return platforms
  }, [isJapan])

  return useCallback(
    (platformShortCode?: PlatformShortcode): boolean => {
      if (!platformShortCode) {
        return false
      }

      return platforms.includes(platformShortCode)
    },
    [platforms],
  )
}
